export default __webpack_public_path__ + "static/media/ic_svc_global_goals.ed34f106.png";